{
  "name": "web-video-player",
  "type": "module",
  "version": "2.73.0",
  "license": "MIT",
  "author": "Beachbody",
  "main": "dist/index.js",
  "module": "dist/index.js",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.js",
      "types": "./dist/index.d.ts"
    }
  },
  "files": [
    "dist"
  ],
  "engines": {
    "node": "^22"
  },
  "scripts": {
    "start": "doppler run -- tsdown --watch",
    "dev": "concurrently 'doppler run -- tsdown --watch' 'http-server dist --cors'",
    "build:local": "doppler run -- tsdown",
    "build": "tsdown",
    "test": "jest --silent",
    "test:watch": "jest --watch --onlyChanged",
    "test:changed": "jest --onlyChanged",
    "test:coverage": "jest --coverage && make-coverage-badge",
    "lint": "eslint src --ext .ts,.tsx && npm run lint:types",
    "lint:types": "tsc --noEmit",
    "config:dev": "doppler secrets download --project digital-web-video-player --config dev --no-file --format env-no-quotes > .env",
    "config:qa": "doppler secrets download --project digital-web-video-player --config qa --no-file --format env-no-quotes > .env",
    "config:stage": "doppler secrets download --project digital-web-video-player --config stage --no-file --format env-no-quotes > .env",
    "config:prod": "doppler secrets download --project digital-web-video-player --config prod --no-file --format env-no-quotes > .env",
    "sandbox": "npm run --prefix sandbox dev"
  },
  "dependencies": {
    "classnames": "2.5.1",
    "easy-peasy": "^6.1.1",
    "lodash": "^4.18.1",
    "mux-embed": "^5.18.0",
    "page-lifecycle": "0.1.2",
    "react": "^19.2.5",
    "react-dom": "^19.2.5",
    "redux-logger": "3.0.6",
    "styled-components": "^6.4.0",
    "ua-parser-js": "1.0.41",
    "uuid": "9.0.1",
    "video.js": "8.23.8",
    "videojs-contrib-quality-levels": "4.1.0",
    "visibilityjs": "2.0.2",
    "yup": "0.29.1"
  },
  "devDependencies": {
    "@babel/core": "7.29.0",
    "@babel/preset-env": "^7.29.2",
    "@babel/preset-react": "^7.28.5",
    "@babel/preset-typescript": "^7.28.5",
    "@rollup/plugin-image": "^3.0.3",
    "@rollup/plugin-replace": "^6.0.3",
    "@testing-library/react": "^16.3.2",
    "@types/chromecast-caf-sender": "1.0.11",
    "@types/classnames": "2.3.4",
    "@types/jest": "25.2.3",
    "@types/lodash": "4.17.24",
    "@types/react": "^19.2.14",
    "@types/react-dom": "^19.2.3",
    "@types/redux-logger": "3.0.13",
    "@types/styled-components": "^5.1.36",
    "@types/ua-parser-js": "0.7.39",
    "@types/uuid": "9.0.8",
    "@types/yup": "0.29.1",
    "@typescript-eslint/eslint-plugin": "^8.58.2",
    "@typescript-eslint/parser": "^8.58.2",
    "babel-jest": "^30.3.0",
    "concurrently": "^9.2.1",
    "dotenv": "^17.4.2",
    "eslint": "^9.39.4",
    "http-server": "^14.1.1",
    "husky": "7.0.4",
    "jest": "^30.3.0",
    "jest-chrome": "^0.8.0",
    "jest-environment-jsdom": "^30.3.0",
    "make-coverage-badge": "1.2.0",
    "rollup-plugin-svg": "2.0.0",
    "tsdown": "^0.15.6",
    "tslib": "2.8.1",
    "typescript": "^5.9.3"
  },
  "sideEffects": false,
  "overrides": {
    "@tootallnate/once": "3.0.1",
    "braces": "3.0.3",
    "form-data": "3.0.4",
    "node-notifier": "8.0.1",
    "micromatch": "4.0.8",
    "rollup": "2.79.2",
    "jest-chrome": {
      "jest": "30"
    }
  },
  "prettier": {
    "printWidth": 120,
    "semi": true,
    "singleQuote": true,
    "trailingComma": "es5"
  },
  "husky": {
    "hooks": {
      "pre-push": "npm run lint"
    }
  }
}
